import type { ImageProps, ImageSource } from "@-/com.npmjs.expo-image";
import { resolveExpoPublicAssetUrl } from "@-/dev.improve.haniverse.lib.expo.public-asset-url";

type SourceProp = ImageProps["source"];
type PlaceholderProp = ImageProps["placeholder"];

function isImageSource(source: unknown): source is ImageSource {
  return source != null && typeof source === "object" && !Array.isArray(source);
}

function resolveImageSourceObject(source: ImageSource): ImageSource {
  if (source.uri == null || source.uri.length === 0) {
    return source;
  }
  return { ...source, uri: resolveExpoPublicAssetUrl(source.uri) };
}

export function resolveImageSource(source: string): string;
export function resolveImageSource(source: string[]): string[];
export function resolveImageSource(source: ImageSource): ImageSource;
export function resolveImageSource(source: ImageSource[]): ImageSource[];
export function resolveImageSource(source: SourceProp): SourceProp;
export function resolveImageSource(source: PlaceholderProp): PlaceholderProp;
export function resolveImageSource(
  source: SourceProp | PlaceholderProp,
): SourceProp | PlaceholderProp {
  if (typeof source === "string") {
    return resolveExpoPublicAssetUrl(source);
  }
  if (Array.isArray(source)) {
    if (source.every((entry): entry is string => typeof entry === "string")) {
      return source.map((entry) => resolveExpoPublicAssetUrl(entry));
    }
    if (source.every(isImageSource)) {
      return source.map((entry) => resolveImageSourceObject(entry));
    }
    return source;
  }
  if (isImageSource(source)) {
    return resolveImageSourceObject(source);
  }
  return source;
}
